import React from 'react'
import PropTypes from 'prop-types'
import { formatCurrency, useViewport } from '@chilecompra/react-kit'
import { Skeleton, Typography } from '@chilecompra/react-kit/components'
import { formatTypeCurrency } from '../../modules/utils/formatTypeCurrency'
import { Card, GridContainer, GridItem } from './SummaryBid.styles'

/**
 * The SummaryBidProducts's component.
 */
const SummaryBidProducts = props => {
  const { amount, description, productCode, loading, name, quantity, typeCurrency, unit, unitPrice } = props
  const { size } = useViewport()

  return (
    <Card enableBorder color="blank">
      <GridContainer alignItems="center" spacing={2}>
        <GridItem md={6} xs={12}>
          <Typography
            color="black1"
            display="inline"
            fontSize="14px"
            fontWeight="bold"
            lineHeight="18px"
            variant="body2"
          >
            {name}
          </Typography>
          <Typography
            color="black3"
            display="inline"
            fontSize="13px"
            lineHeight="18px"
            margin="0 0 0 4px"
            variant="body2"
          >
            ID: {productCode}
          </Typography>
          <Typography color="black1" fontSize="14px" lineHeight="18px" margin="4px 0 0" variant="body2">
            {description}
          </Typography>
        </GridItem>
        <GridItem md={2} xs={12}>
          <Typography
            align={size.isDownToTiny ? 'left' : 'right'}
            color="black3"
            fontSize="14px"
            lineHeight="18px"
            variant="body2"
          >
            Cantidad
          </Typography>
          <Typography
            align={size.isDownToTiny ? 'left' : 'right'}
            color="black1"
            fontSize="16px"
            fontWeight="bold"
            lineHeight="26px"
            variant="body2"
          >
            {loading ? <Skeleton /> : `${formatCurrency(quantity)} ${unit || ''}`}
          </Typography>
        </GridItem>
        <GridItem md={2} xs={12}>
          <Typography
            align={size.isDownToTiny ? 'left' : 'right'}
            color="black3"
            fontSize="14px"
            lineHeight="18px"
            variant="body2"
          >
            Valor unitario
          </Typography>
          <Typography
            align={size.isDownToTiny ? 'left' : 'right'}
            color="black1"
            fontSize="16px"
            fontWeight="bold"
            lineHeight="26px"
            variant="body2"
          >
            {loading ? <Skeleton /> : formatTypeCurrency(typeCurrency, unitPrice, true)}
          </Typography>
        </GridItem>
        <GridItem md={2} xs={12}>
          <Typography
            align={size.isDownToTiny ? 'left' : 'right'}
            color="black3"
            fontSize="14px"
            lineHeight="18px"
            variant="body2"
          >
            Subtotal
          </Typography>
          <Typography
            align={size.isDownToTiny ? 'left' : 'right'}
            color="black1"
            fontSize="16px"
            fontWeight="bold"
            lineHeight="26px"
            variant="body2"
          >
            {loading ? <Skeleton /> : formatTypeCurrency(typeCurrency, amount, true)}
          </Typography>
        </GridItem>
      </GridContainer>
    </Card>
  )
}

SummaryBidProducts.defaultProps = {
  amount: 0,
  description: '',
  loading: false,
  name: '',
  quantity: 0,
  typeCurrency: 'CLP',
  unit: '',
  unitPrice: 0
}

SummaryBidProducts.propTypes = {
  amount: PropTypes.number,
  description: PropTypes.string,
  productCode: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  name: PropTypes.string,
  quantity: PropTypes.number,
  typeCurrency: PropTypes.string,
  unit: PropTypes.string,
  unitPrice: PropTypes.number
}

export default SummaryBidProducts
